import React from 'react';
import './TicketList.scss';
import PostalEntry from '../PostalEntry/PostalEntry';
import ReactHtmlParse from 'html-react-parser';
import useTickets from '../../hooks/useTickets';
import useAgeVerification from '../../hooks/useAgeVerification';
import AgeVerificationPopup from '../common/AgeVerificationPopup';
import { TitleText, SubtitleText } from 'raffle-house-uikit';
import SingleBundleCard from './SingleBundleCard';

const TicketList = (props) => {
  const {
    prizeId,
    raffles,
    isExpired,
    currentRaffle,
    title,
    subtitle,
    theme = 'light',
    reference,
    bonusDraw,
    user,
  } = props;
  const { type, loading, activeTicket, addToBasket, result, ticketsBundles } =
    useTickets({ prizeId, isDouble: raffles.length > 1 });
  const { showAgePopup, requireAgeVerification, confirmAge, closeAgePopup } =
    useAgeVerification();

  const loyalty = user?.loyalty ?? null;

  if (!result || !ticketsBundles?.length) {
    return null;
  }

  const handleAddToBasket = (ticket) => () => {
    requireAgeVerification(() => addToBasket(ticket)());
  };

  return (
    <div className="ticket-container" ref={reference}>
      {title || subtitle ? (
        <div className="ticket-text-container">
          {Boolean(title) && (
            <TitleText
              isCentered
              as="h2"
              variant={'primary'}
              color={`${theme === 'light' ? 'color-1' : 'color-5'}`}
            >
              {title ? ReactHtmlParse(title) : null}
            </TitleText>
          )}
          {Boolean(subtitle) && (
            <SubtitleText
              isCentered
              color={`${theme === 'light' ? 'color-1' : 'color-5'}`}
            >
              {subtitle ? ReactHtmlParse(subtitle) : null}
            </SubtitleText>
          )}
        </div>
      ) : null}
      <div className="tickets-list">
        <div className="tickets-list__bundles">
          {ticketsBundles.map((ticket, index) => (
            <SingleBundleCard
              key={index}
              isDouble={raffles.length > 1}
              index={index}
              ticketsCount={ticket.tickets}
              ticketBundle={ticket}
              prize={result.prize}
              generalSettings={result.generalSettings}
              discountRates={result.discountRates}
              activeRaffles={raffles}
              activeTicket={activeTicket}
              loading={loading}
              isExpired={isExpired}
              onBuy={handleAddToBasket}
              bonusDraw={bonusDraw}
              loyalty={loyalty}
            />
          ))}
        </div>
      </div>
      <div className="postal-entry">
        <PostalEntry
          loading={loading}
          theme={raffles.length > 1 ? 'light' : theme}
        />
      </div>
      {showAgePopup && (
        <AgeVerificationPopup onConfirm={confirmAge} onClose={closeAgePopup} />
      )}
    </div>
  );
};

export default TicketList;
